
    import './styles.scoped.css';
    export default {
  "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_nlh1l_97",
  "enable-motion": "awsui_enable-motion_lm6vo_nlh1l_97",
  "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_nlh1l_98",
  "layout-main-inner": "awsui_layout-main-inner_lm6vo_nlh1l_117",
  "root": "awsui_root_lm6vo_nlh1l_137",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_nlh1l_138",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_nlh1l_144",
  "layout": "awsui_layout_lm6vo_nlh1l_117",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_nlh1l_155",
  "layout-main": "awsui_layout-main_lm6vo_nlh1l_117",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_nlh1l_165",
  "refresh": "awsui_refresh_lm6vo_nlh1l_168",
  "unfocusable": "awsui_unfocusable_lm6vo_nlh1l_175",
  "drawer": "awsui_drawer_lm6vo_nlh1l_179",
  "drawer-mobile": "awsui_drawer-mobile_lm6vo_nlh1l_185",
  "drawer-closed": "awsui_drawer-closed_lm6vo_nlh1l_188",
  "drawer-refresh": "awsui_drawer-refresh_lm6vo_nlh1l_191",
  "drawer-hidden": "awsui_drawer-hidden_lm6vo_nlh1l_203",
  "has-divider-with-splitpanel": "awsui_has-divider-with-splitpanel_lm6vo_nlh1l_206",
  "opaque-background": "awsui_opaque-background_lm6vo_nlh1l_209",
  "drawer-content": "awsui_drawer-content_lm6vo_nlh1l_213",
  "toggle": "awsui_toggle_lm6vo_nlh1l_254",
  "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_nlh1l_259",
  "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_nlh1l_263",
  "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_nlh1l_266",
  "button-toggles-container": "awsui_button-toggles-container_lm6vo_nlh1l_276",
  "button-toggles-container-is-hidden": "awsui_button-toggles-container-is-hidden_lm6vo_nlh1l_281",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_nlh1l_295",
  "breadcrumbs-desktop-refresh": "awsui_breadcrumbs-desktop-refresh_lm6vo_nlh1l_299",
  "breadcrumbs-desktop-refresh-with-notifications": "awsui_breadcrumbs-desktop-refresh-with-notifications_lm6vo_nlh1l_306",
  "breadcrumbs-desktop-sticky-header": "awsui_breadcrumbs-desktop-sticky-header_lm6vo_nlh1l_309",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_nlh1l_313",
  "content-header-wrapper-refresh": "awsui_content-header-wrapper-refresh_lm6vo_nlh1l_316",
  "content-header-wrapper-overlapped": "awsui_content-header-wrapper-overlapped_lm6vo_nlh1l_319",
  "content-wrapper": "awsui_content-wrapper_lm6vo_nlh1l_323",
  "content-wrapper-refresh": "awsui_content-wrapper-refresh_lm6vo_nlh1l_326",
  "content-refresh": "awsui_content-refresh_lm6vo_nlh1l_332",
  "content-refresh-overlapped": "awsui_content-refresh-overlapped_lm6vo_nlh1l_335",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_nlh1l_339",
  "content-wrapper-first-child": "awsui_content-wrapper-first-child_lm6vo_nlh1l_342",
  "content-header-wrapper-first-child": "awsui_content-header-wrapper-first-child_lm6vo_nlh1l_342",
  "navigation-toggle": "awsui_navigation-toggle_lm6vo_nlh1l_347",
  "tools-toggle": "awsui_tools-toggle_lm6vo_nlh1l_352",
  "navigation": "awsui_navigation_lm6vo_nlh1l_347",
  "navigation-close": "awsui_navigation-close_lm6vo_nlh1l_364",
  "tools": "awsui_tools_lm6vo_nlh1l_352",
  "tools-close": "awsui_tools-close_lm6vo_nlh1l_376",
  "notifications": "awsui_notifications_lm6vo_nlh1l_380",
  "breadcrumbs": "awsui_breadcrumbs_lm6vo_nlh1l_295",
  "content": "awsui_content_lm6vo_nlh1l_313",
  "hide": "awsui_hide_lm6vo_nlh1l_401",
  "mobile": "awsui_mobile_lm6vo_nlh1l_411",
  "open": "awsui_open_lm6vo_nlh1l_417",
  "navigation-panel-exit-state": "awsui_navigation-panel-exit-state_lm6vo_nlh1l_422"
};
  